const routes = {
  main: {
    path: '/',
  },
  service: {
    path: '/service',
  },
  team: {
    path: '/team',
  },
  contact: {
    path: '/contact',
  },
  personal: {
    path: '/personal',
  },
  prices: {
    path: '/prices',
  },
  disclosure: {
    path: '/disclosure',
  },
  agreement: {
    path: '/agreement',
  },
  privacy: {
    path: '/privacy',
  },
};

export default routes;
